

import React from "react";

const HoverCircles = () => {
  const containerStyle = {
    display: "flex",
    flexWrap: "wrap", // Allow wrapping of items to the next line
    justifyContent: "center",
    alignItems: "center",
    padding: "0 15px",
    gap: "20px",
    margin: "0 auto",
    width: "100%",
  };

  const circleStyle = {
    position: "relative",
    width: "100%",
    maxWidth: "280px", // Set a maximum width for each circle
    height: "280px",
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    color: "#000",
    fontSize: "14px",
    fontWeight: "bold",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #000",
     boxShadow: "20px 20px 40px rgba(0, 0, 0, 0.2)",
    transition: "background-color 0.3s ease, color 0.3s ease, border 0.3s ease",
    cursor: "pointer",
    boxSizing: "border-box",
  };

  const hoverStyle = {
    backgroundColor: "#000",
    color: "#FFFFFF",
    border: "2px solid blue",
  };

  const titleContainerStyle = {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "30px",
    fontWeight: "bold",
    color: "#FFA500",
  };

  const circles = [
    {
      title: "	Master Cutting-Edge Technology:",
      description:
        "Learn how to build dynamic and scalable web applications using React JS, one of the most popular front-end libraries in the tech industry.",
    },
    {
      title: "	Real-World Applications:",
      description:
        "Discover how React JS is used by top companies such as Facebook, Instagram, and Netflix to build complex, high-performance web applications.",
    },
    {
      title: "	Cost-Effective Learning:",
      description:
        "Learn React JS through interactive exercises and real-world examples, gaining valuable experience without the need for expensive tools or frameworks.",
    },
    {
      title: "	Industry Insights:",
      description:
        "Stay updated with the latest trends in web development, including hooks, state management, and server-side rendering with Next.js",
    },
  ];

  return (
    <div>
      <div style={titleContainerStyle}>
        <span style={{ color: "#000", fontFamily: "roboto" }}>WHY YOU SHOULD LEARN</span>{" "}
        <span style={{ color: "#FFA500", fontFamily: "roboto" }}>REACT</span>
      </div>

      <div style={containerStyle}>
        {circles.map((circle, index) => (
          <div
            key={index}
            style={circleStyle}
            onMouseEnter={(e) => Object.assign(e.currentTarget.style, hoverStyle)}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = circleStyle.backgroundColor;
              e.currentTarget.style.color = "#000";
              e.currentTarget.style.border = circleStyle.border;
            }}
          >
            <h3
              style={{
                margin: "10px 0",
                fontSize: "20px",
                color: "orange",
                fontFamily: "roboto",
              }}
            >
              {circle.title}
            </h3>
            <p
              style={{
                fontSize: "14px",
                padding: "10px",
                margin: "0",
                textAlign: "center",
              }}
              dangerouslySetInnerHTML={{ __html: circle.description }}
            />
          </div>
        ))}
      </div>

      <style jsx>{`
        @media (max-width: 1200px) {
          h3 {
            font-size: 18px;
          }

          p {
            font-size: 12px;
          }
        }

        @media (max-width: 768px) {
          .container {
            flex-direction: column;
          }

          .circle {
            max-width: 90%; // Adjust the width for mobile
            height: 240px;
          }

          .title {
            font-size: 24px;
          }
        }

        @media (max-width: 480px) {
          h3 {
            font-size: 16px;
          }

          p {
            font-size: 12px;
          }

          .circle {
            height: 220px;
          }
        }
      `}</style>
    </div>
  );
};

export default HoverCircles;



